var theTabs = document.querySelectorAll(".tabs-wrap__items > .tabs-wrap__items-item");

function theTabClicks(tabClickEvent) {
  var clickedTab = tabClickEvent.currentTarget;
  var tabParent = tabClickEvent.currentTarget.parentNode.parentNode.parentNode;
  var theTabs = tabParent.querySelectorAll(
    ".tabs-wrap__items > .tabs-wrap__items-item"
  );
  for (var i = 0; i < theTabs.length; i++) {
    theTabs[i].classList.remove("active");
  }

  clickedTab.classList.add("active");
  tabClickEvent.preventDefault();
  var contentPanes = tabParent.querySelectorAll(".tab-content");
  for (i = 0; i < contentPanes.length; i++) {
    contentPanes[i].classList.remove("active");
  }

  var activePaneId = this.getAttribute("data-tab");
  var activePane = tabParent.getElementsByClassName(activePaneId);
 
  for (i = 0; i < activePane.length; i++) {
    activePane[i].classList.add("active");
}
  
}
for (i = 0; i < theTabs.length; i++) {
  theTabs[i].addEventListener("click", theTabClicks);
}